define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"csi",
	"csi/action",
	"csi/action/Aggregate",
	"csi/action/Delete",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml"
], function(declare,lang,domClass,csi,csiAction,Aggregate,Delete,ViewRef,locale,ToolbarPluginSwitchboard,xml) {

	return declare(ToolbarPluginSwitchboard, {
		_bSpecAccess: false,

		postCreate: function() {
			// summary: store material spec for later use and turn Go button into delete icon
			var	view = this.actionToolbar.view;
			var	spec = view.getViewNode();

			view.urlMaterialSpec = spec.$URL;
			this._bSpecAccess = xml.nodeHasRight(spec, xml.RIGHT_WRITE);
			this.inherited(arguments);

			// use go button for delete action
			var	a = this._deleteAction = lang.mixin(new Delete(), {
				m_id: "DeleteSeasonAvailability",
				m_postAction: lang.hitch(this, this._postActionDelete)
			});
			a.resolve(locale.resolver, this.defAction.m_rcTarget);
			this._mixinActionProperties(this.goNode, a);
			domClass.remove(this.goNode.domNode, "nodisplay");
		},

		_canGo: function(/*Context?*/ctx) {
			// summary: determine if have access to delete current selection
			return this._deleteAction.hasAccess(ctx.view.getContext(this.get("value"), ctx.view.urlMaterialSpec, "SeasonAvailability"));
		},

		_getButtonAction: function(/*csi.LocaleResolver*/lr) {
			// summary: create action for button - default is to popup view of switchboard items
			return lang.mixin(new Aggregate(), {
				m_id: "MaterialSelectSeasonAvailability",
				aggregateId: "SeasonAvailability",
				aggregateClass: "MaterialSeasonAvailability",
				aggregateClassIds: ["AvailabilitySeason"],
				bAggregateNew: true,
				classController: "MaterialSpec.SeasonAvailabilityController",
				m_accessAction: lang.hitch(this, this._onAccessSeasons),
				m_right: null,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "Seasons",
					m_url: "centric://APPAREL/Views"
				})
			});
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: default store is that of parent's reverse relation
			var	options = this.inherited(arguments);
			options.request.addParameter("Qry.Value.Path", "Child:AvailabilitySeason");
			return options;
		},

		_onAccessSeasons: function(/*Context*/ctx, /*Action*/action) {
			// summary: allow access if has write access on spec node
			return !ctx.isReadOnly() && this._bSpecAccess;
		},

		_onGo: function(/*Event*/e) {
			// summary: delete currently selected item
			csiAction.invoke(this.actionToolbar.view, this.domNode, this._deleteAction, {
				m_urlNode: this.get("value")
			});
		},

		_postActionDelete: function(/*Controller*/ac) {
			// summary: refresh store
			this.refreshStore(null, true);
		},

		_postClickButton: function(/*Controller*/ac) {
			// summary: refresh store to new url if one is added
			if (ac.urlsAppended[0]) {
				this.refreshStore(ac.urlsAppended[0]);
			}

			return true;
		}
	});
});